import ImgEle from './Components/Elements/ImgEle';

const Image = ({ item, items }) => {
    const { url, foreign_landing_url, title, creator, creator_url, license_version, license_url, license, titleHyperLink, imageHyperLink } = item;
    const { isDisableDefaultlLink, isTitle, isCreator, isLicenses } = items;


    return (
        <div className='imgArea'>
            <ImgEle isDisableDefaultlLink={isDisableDefaultlLink} foreign_landing_url={foreign_landing_url} url={url} imageHyperLink={imageHyperLink} />

            {isTitle && <div>
                <LinkProvider text={title} className='title' link={titleHyperLink || (isDisableDefaultlLink ? '' : foreign_landing_url)} />
            </div>}

            {isCreator && (
                <div className="creator">
                    <span>By</span> {<LinkProvider text={creator} className='' link={isDisableDefaultlLink ? '' : creator_url} />}
                </div>
            )}

            {isLicenses && (
                <div className="licenses">
                    <span>Is licensed under</span> {<LinkProvider text={license} className='' link={isDisableDefaultlLink ? '' : license_url} />}{license_version}
                </div>
            )}
        </div>
    );
};

export default Image;

const LinkProvider = ({ text, className, link }) => {
    return link ? <a href={link} className={className} target="_blank" rel="noopener noreferrer">{text}</a> : <div className={className}>{text}</div>;
}
